///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Alerts Module
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import $ from 'jquery';

const alerts = {
    // Register delegated handlers that are resilient to timing and dynamic DOM
    async register() {
        $(() => {
            // Info/alert modal
            $(document)
                .off('hide.bs.modal.alerts', '#alerts-modal')
                .on('hide.bs.modal.alerts', '#alerts-modal', function() {
                    $(this)
                        .trigger('ep.on-close')
                        .off('ep.on-close.alerts');
                });

            // Confirm modal
            $(document)
                .off('hide.bs.modal', '#confirm-modal')
                .on('hide.bs.modal', '#confirm-modal', function() {
                    $(this)
                        .trigger('ep.on-close', [$('#confirm-modal').data('resp')])
                        .off('ep.on-close.alerts');
                });

            // Primary button triggers a positive response
            $(document)
                .off('click.alerts', '#confirm-modal .btn-primary')
                .on('click.alerts', '#confirm-modal .btn-primary', function() {
                    $('#confirm-modal').data('resp', true).modal('hide');
                });
        });
    },

    /**
     * @param {*} title
     * @param {*} body
     * @param {*} callback
     */
    show: function (title, body, callback = null) {
        $('#alerts-modal .modal-title').html(title);
        $('#alerts-modal .modal-body').html(body);

        if (callback) {
            $('#alerts-modal')
                .off('ep.on-close.alerts')
                .on('ep.on-close.alerts', callback);
        }

        $('#alerts-modal').modal('show');
    },

    /**
     * @param {*} title
     * @param {*} body
     * @param {*} callback
     */
    confirm: function (title, body, callback = null) {
        $('#confirm-modal').data('resp', false);
        $('#confirm-modal .modal-title').html(title);
        $('#confirm-modal .modal-body').html(body);

        // Store optional callback on the modal element for per-instance handling
        if (callback) {
            $('#confirm-modal')
                .off('ep.on-close.alerts')
                .on('ep.on-close.alerts', (event, response) => callback(response));
        }

        $('#confirm-modal').modal('show');
    },

    /**
     * @param {*} errors
     * @param {*} callback
     */
    showErrors: function (errors, callback = null) {
        var addedItems = false;
        var message = 'You have errors with your submission. Please check the data you entered and try again.';

        if (errors.message) {
            message = errors.message;
        }

        if (errors.errors) {
            for (var i in errors.errors) {
                $('[name=' + i + ']').addClass('is-invalid');

                if (errors.errors[i]) {
                    if (!addedItems) {
                        message = '<b>Whoops!</b> There were some problems with your submission:';
                        message = message + '<br><ul class="submission-errors">';
                        addedItems = true;
                    }

                    message = message + '<li>' + errors.errors[i] + '</li>';
                }
            }
        }

        if (addedItems) {
            message = message + '</ul>';
        }

        // Remove the is-invalid class when the errored field is updated or changed
        $(document)
            .off('change.formError, keyup.formError', '.is-invalid')
            .on('change.formError, keyup.formError', '.is-invalid', function () {
                $(this).removeClass('is-invalid');
            });

        this.show('Submission Errors', message, callback);
    },
};

export default alerts;
